import {linkToApp} from '../../url/linkToApp';
import Button from '../design_system/Button';
import {ButtonColor, ButtonSize} from '../design_system/Button/options';
import useAppTheme from '../design_system/hooks/useAppTheme';
import TitleText from '../design_system/typography/TitleText';
import Flex from '../layout/flex/Flex';

import {css} from '@emotion/react';
import React from 'react';
import {useTranslation} from 'react-i18next';

export interface Props {}

// Bare viewer is logged in but the profile is not complete
export default function RegistrationFormBareViewer(_: Props): JSX.Element {
  const profileWizardUrl = linkToApp('/profile/wizard');
  const {spacing} = useAppTheme();
  const {t} = useTranslation();

  return (
    <Flex
      direction="column"
      sx={css({
        width: '100%',
        height: 160,
        rowGap: spacing.x32,
      })}
    >
      <TitleText
        size="XS"
        sx={css({
          textAlign: 'center',
        })}
      >
        {t('components.event-registration-form.profile-required-message')}
      </TitleText>
      <Button
        color={ButtonColor.ACCENT}
        label={t('components.event-registration-form.setup-profile-cta-label')}
        size={ButtonSize.LARGE}
        sx={css({
          width: '100%',
        })}
        to={profileWizardUrl}
      />
    </Flex>
  );
}
